export enum EntityArchiveScope {
  workingSite
}
